import React from "react";
import { Radio } from "antd";
import { Title, RadioWrapper, Divider, DescriptionSpan } from "./styles";
import TIFFRecommendAnExchangeFrom from "./TIFFRecommendAnExchangeFrom";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import TooltipComponent from '../../../../../CommonComponents/Info/Tooltip/TooltipComponent';
import { getPrimaryAccount } from "../../../../../utils/sessionUtil";
import { startDate, todayDate, moveIntoErrorPosition } from "../../../../../utils/commonUtil";
import  PropTypes from 'prop-types';
import PopUp from "./PopUp";

class TIFFTypeSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectTiffOption: "",
      exchangeIntoPool: {},
      totalIntoPools: 0,
      setKeys: false,
      valueTiffExchangeAmount: null,
      isDirty: false,
      intoTiffButton: false,
      tiffAvailableBalance: 0,
      poolCount: 0,
      exitPopUp: false,
      onChangeOption: false,
      avoidNextStep: false,
      accDataLoading: false,
      tiffFormInfo: {},
      isEditIntoEnable: true,
      isMaxPoolLimit: false,
      popUpPoolName: ""
    };
  }

  componentWillMount() {
    if (this.props.selectedTiffOption === "exchangeintoTIFF") {
      if (this.props.stepOneSet) {
        this.setState((prevState, props) => {
          let { exchangeIntoPool, totalIntoPools } = prevState;
          exchangeIntoPool = this.props.dataStepOne.inputValue;
          totalIntoPools = this.props.dataStepOne.totalAmountIntoPool;
          return {
            exchangeIntoPool: exchangeIntoPool,
            cloneExchangeIntoPool: exchangeIntoPool,
            totalIntoPools: totalIntoPools,
            selectTiffOption: this.props.selectedTiffOption
          };
        });
      }
    } else if (this.props.selectedTiffOption === "exchangeFromTIFF") {
      if (this.props.stepOneSet) {
        this.setState((prevState, props) => {
          let { valueTiffExchangeAmount, tiffAvailableBalance } = prevState;
          valueTiffExchangeAmount = this.props.dataStepOne.valueTiffExchangeAmount;
          tiffAvailableBalance = this.props.dataStepOne.tiffAvailableBalance;
          return {
            valueTiffExchangeAmount: valueTiffExchangeAmount,
            tiffAvailableBalance: tiffAvailableBalance,
            selectTiffOption: this.props.selectedTiffOption
          };
        });
      }
    }
    this.props.requestDataTiff({
      method: "GET",
      page: "recommendAnExchange",
      url: `/donor-portal/api/investment/${
        getPrimaryAccount().userId
        }/findInvestmentPoolOptionsByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          7
        )}&endDateStr=${todayDate()}`
    });
    this.props.getExchangeDate({
      method: "GET",
      page: "ViewAndEditInto",
      url: `/api/dates?Page=Expected_Exchange_Date`,
      isExternal: false
    });
    if(this.props.isEdit && this.props.getTiffDetails.transactionId) {
      const transactionId = this.props.getTiffDetails.transactionId;
      this.props.getTiffFormInfo({
        method: "GET",
        url: `/donor-portal/api/exchange/${
          getPrimaryAccount().userId
          }/getPoolInformation?isEdit=true&transactionId=${transactionId}`
      });
    } else {
      this.props.getTiffFormInfo({
        method: "GET",
        url: `/donor-portal/api/exchange/${
          getPrimaryAccount().userId
          }/getPoolInformation?isEdit=false`
      });
    }
    window.scrollTo(0, 0);
  }
  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.accDataLoading &&
      !this.state.setKeys &&
      !this.props.stepOneSet &&
      !nextProps.tiifInfoLoading
    ) {
      this.setState((prevState, props) => {
        const { exchangeIntoPool } = prevState;
        const { investmentPools } = props;
        let availableBalance = 0;
        if (investmentPools) {
          investmentPools.filter((item) => {
            if (item.poolName === "TIFF Multi-Asset Pool") {
              availableBalance = item.availableBalance;
            } else {
              exchangeIntoPool[item.poolId] = "";
            };
          }
          );
        }
        if (nextProps.isDisabled) {
          var total = 0;
          nextProps.getTiffDetails.exchangeFrom.map(data => {
            for (var key in exchangeIntoPool) {
              if (Number(key) === Number(data.poolId)) {
                exchangeIntoPool[key] = data.value;
                total += Number(data.value);
              }
            }
          });
          return {
            setKeys: true,
            exchangeIntoPool: exchangeIntoPool,
            cloneExchangeIntoPool: exchangeIntoPool,
            totalIntoPools: total,
            valueTiffExchangeAmount: this.props.exchangeAmount,
            tiffAvailableBalance: availableBalance,
            accDataLoading: nextProps.accDataLoading,
            tiffFormInfo: nextProps.tiifInfoData,
            selectTiffOption: nextProps.selectedTiffOption
          };
        }
        return {
          setKeys: true,
          tiffAvailableBalance: availableBalance,
          exchangeIntoPool: exchangeIntoPool,
          cloneExchangeIntoPool: exchangeIntoPool,
        };
      });
    }
    if (
      !this.props.accDataLoading &&
      this.props.accDataPools !== nextProps.accDataPools
    ) {
      this.props.setExchangeIntoTiff(this.props.accDataPools.investmentPools);
    }
    if (this.props.selectedTiffOption !== nextProps.selectedTiffOption) {
      this.props.updateStepper();
    }
  }

  setInputValues = value => {
    let isUpdate = "";
    let total = 0;
    let count = 0;
    const { exchangeIntoPool } = this.state;
    let exchangeIntoPoolOld = JSON.parse(JSON.stringify(exchangeIntoPool));
    exchangeIntoPoolOld[value.key] = value.value;
    isUpdate = (JSON.stringify(exchangeIntoPool) === JSON.stringify(exchangeIntoPoolOld));
    this.setState({ exchangeIntoPool: exchangeIntoPoolOld });
    Object.keys(exchangeIntoPoolOld).forEach(key => {
      if (exchangeIntoPoolOld[key] !== "") {
        const add = parseFloat(exchangeIntoPoolOld[key]).toFixed(2);
        total = Number(total) + Number(add);
        count++;
      }
    });
    this.setState({ totalIntoPools: total, poolCount: count, isEditIntoEnable: isUpdate });
  };
  blurOutDollar = (poolName, value, availableBalance, poolId) => {
    const { exchangeIntoPool } = this.state;
    if (value >= availableBalance * 0.9) {
      this.setState({ isMaxPoolLimit: true, popUpPoolName: poolName })
    }
    const val = exchangeIntoPool[poolId];
    if (val != "") {
      const dec = parseFloat(val).toFixed(2);
      exchangeIntoPool[poolId] = dec;
      this.setState({ exchangeIntoPool: exchangeIntoPool });
    }
  };
  selectTiffOption = e => {
    const { value } = e.target;
    if (
      this.state.totalIntoPools === 0 &&
      this.state.valueTiffExchangeAmount === null
    ) {
      this.props.selectTiffOption(value);
      this.props.updateStepper();
      this.setState({
        selectTiffOption: value
      });
    }
    else {
      this.setState({ onChangeOption: true });
      this.props.updateStepper();
    }
  };
  setStepOne = () => {
    if (this.props.selectedTiffOption === "exchangeintoTIFF") {
      const poolEntered = [];
      this.props.accDataPools.investmentPools.map(obj => {
        for (var key in this.state.exchangeIntoPool) {
          if (this.state.exchangeIntoPool.hasOwnProperty(key)) {
            if (
              obj.poolId === Number(key) &&
              this.state.exchangeIntoPool[key] != "" &&
              this.state.exchangeIntoPool[key] > 0 //To avoid type checking 
            ) {
              const poolObj = {
                poolId: obj.poolId,
                poolName: obj.poolName,
                poolCategory: obj.poolCategory,
                pricePerUnit: obj.pricePerUnit,
                availableBalance: obj.availableBalance,
                availableUnits: obj.availableUnits,
                isRise: obj.isRise,
                value: this.state.exchangeIntoPool[key],
                dateOfPricePerUnit: obj.dateOfPricePerUnit
              };
              poolEntered.push(poolObj);
            }
          }
        }
      });
      this.props.setStepOne({
        exchangeIntoPoolData: poolEntered,
        inputValue: this.state.exchangeIntoPool,
        poolCount: this.state.poolCount,
        totalAmountIntoPool: this.state.totalIntoPools
      });
    } else {
      this.props.setStepOne({
        tiffAvailableBalance: this.state.tiffAvailableBalance,
        valueTiffExchangeAmount: this.state.valueTiffExchangeAmount
      });
    }
  };
  setIntoTiff = value => {
    if (value <= this.state.tiffAvailableBalance) {
      this.setState({ valueTiffExchangeAmount: value, isDirty: true });
    }
  };
  onExitClick = () => {
    this.setState({ exitPopUp: true });
  };
  exitFlow = () => {
    this.props.history.push("/");
    this.props.resetFlow();
    this.setState({ exitPopUp: false });
  };
  stayOnFlow = () => {
    this.setState({ exitPopUp: false });
  };
  checked = val => this.setState({
    valueTiffExchangeAmount: val ? this.state.tiffAvailableBalance : null
  });
  onChangeOptionConfirm = () => {
    const { selectTiffOption } = this.state;
    let value = "";
    if (selectTiffOption === "exchangeintoTIFF") {
      value = "exchangeFromTIFF";
    } else if (selectTiffOption === "exchangeFromTIFF") {
      value = "exchangeintoTIFF";
    }
    this.props.resetFlow();
    this.props.selectTiffOption(value);
    this.props.history.push({
      params: undefined
    });
    this.setState((prevState, props) => {
      const { exchangeIntoPool } = prevState;
      const { investmentPools } = props;
      let availableBalance = 0;

      if (investmentPools) {
        investmentPools.filter((item) => {
          if (item.poolName === "TIFF Multi-Asset Pool") {
            availableBalance = item.availableBalance;
          } else {
            exchangeIntoPool[item.poolId] = "";
          };
        }
        );
      }
      return {
        tiffAvailableBalance: availableBalance,
        exchangeIntoPool: exchangeIntoPool,
        cloneExchangeIntoPool: exchangeIntoPool,
        selectTiffOption: value,
        onChangeOption: false,
        valueTiffExchangeAmount: null,
        totalIntoPools: 0
      };
    });
  };
  triggerPopUp = () => {
    this.setState({
      avoidNextStep: true
    });
  };
  enablePillUpdateInto = () => {
    return JSON.stringify(this.props.dataStepOne.inputValue) === JSON.stringify(this.state.exchangeIntoPool);
  };
  enablePillUpdateFromStepOne = () => {
    return this.props.dataStepOne.valueTiffExchangeAmount === this.state.valueTiffExchangeAmount;
  };
  enableFromStepOne = () => {
    if (this.state.tiffAvailableBalance < 50000)
      return this.state.tiffAvailableBalance !== this.state.valueTiffExchangeAmount;

    else {
      return !(this.state.valueTiffExchangeAmount >= 50000)
    }
  };
  enableUpdateFromStepOne = () => {
    return this.props.exchangeAmount === this.state.valueTiffExchangeAmount;
  };

  nextFromValidation = () => {
      if(this.state.valueTiffExchangeAmount !== null && !this.enableFromStepOne()){
        return true
      } else {
        this.setState({isDirty: true })
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields");
        }, 0);
        return false
      }
  } 

  enableNextButton = () => {
    const percentage = (this.state.totalIntoPools / this.props.availableBalance) * 100;
    return (percentage > 90);
  };

  nextIntoValidation = () => {
      if(!this.state.totalIntoPools == 0 && !this.enableNextButton()) {
        return true
      } else {
        this.setState({intoTiffButton: true})
        return false
      }   
  }

  editUpdateValidation = (type) => {
    if(type === "into"){
      return this.nextIntoValidation()
    } else {
      return this.nextFromValidation()
    }
  }

  render() {
    return (
      <>
        {this.state.tiifInfoLoading ? (
          <Preloader />
        ) : (
            <>
              {typeof(this.props.disableFromOption) === "string" ?
                <Preloader styling="p0 w25" /> :
                <>
                <Title>Type of TIFF exchange</Title>
                  <RadioWrapper>
                    <Radio.Group
                      onChange={this.selectTiffOption}
                      value={this.props.selectedTiffOption}
                    >
                      <Radio
                        id="rdExchangeFromTIFF"
                        value="exchangeFromTIFF"
                        disabled={this.props.isDisabled || this.props.disableFromOption ? true : false}
                      >
                        <DescriptionSpan>Exchange from TIFF</DescriptionSpan>
                        {this.props.disableFromOption && <TooltipComponent text="You are currently unable to perform an exchange from TIFF." />}
                      </Radio>
                      <Radio
                        id="rdExchangeIntoTIFF"
                        value="exchangeintoTIFF"
                        disabled={this.props.isDisabled ? true : false}
                      >
                        <DescriptionSpan>Exchange into TIFF</DescriptionSpan>
                      </Radio>
                    </Radio.Group>
                  </RadioWrapper>
                  <Divider />
                </>
              }

              {this.props.selectedTiffOption && (
                <TIFFRecommendAnExchangeFrom
                  type={this.props.selectedTiffOption}
                  poolData={this.props.investmentPools}
                  setInputValues={this.setInputValues}
                  inputValues={this.state.exchangeIntoPool}
                  cloneExchangeIntoPool={this.state.cloneExchangeIntoPool}
                  isEdit={this.props.isEdit}
                  inputValuesLoading={this.props.inputValuesLoading}
                  tiffBalanceAmount={this.state.tiffAvailableBalance}
                  valueExchangeFromTiff={this.state.valueTiffExchangeAmount}
                  setIntoTiff={val => this.setIntoTiff(val)}
                  checked={val => this.checked(val)}
                  totalDollar={this.state.totalIntoPools}
                  setStepOne={this.setStepOne}
                  blurOutDollar={this.blurOutDollar}
                  tiffPoolName={this.props.tiffPoolName}
                  availableBalance={this.props.availableBalance}
                  firstTiffExchnageFlag={this.props.firstTiffExchnageFlag}
                  triggerPopUp={this.triggerPopUp}
                  onExitClick={this.onExitClick}
                  enableUpdateInto={this.state.isEditIntoEnable}
                  enablePillUpdateInto={this.enablePillUpdateInto}
                  enableFromStepOne={this.enableFromStepOne}
                  enableUpdateFromStepOne={this.enableUpdateFromStepOne}
                  enablePillUpdateFromStepOne={this.enablePillUpdateFromStepOne}
                  getTiffDetails={this.props.getTiffDetails}
                  submitUpdateTiff={this.props.submitUpdateTiff}
                  isDisabled={this.props.isDisabled}
                  accDataLoading={this.state.accDataLoading}
                  stepOneData={this.props.stepOne}
                  tiffFormInfo={this.state.tiffFormInfo}
                  nextFromValidation={this.nextFromValidation}
                  isDirty={this.state.isDirty}
                  nextIntoValidation={this.nextIntoValidation}
                  editUpdateValidation={this.editUpdateValidation}
                />
              )}
              <PopUp
                type="EXIT"
                visible={this.state.exitPopUp}
                onOk={this.exitFlow}
                onCancel={this.stayOnFlow}
              />
              <PopUp
                type="OPTION_CHNAGE"
                visible={this.state.onChangeOption}
                onOk={this.onChangeOptionConfirm}
                onCancel={() => {
                  this.setState({ onChangeOption: false });
                }}
              />
              <PopUp
                type={
                  this.props.firstTiffExchnageFlag
                    ? "FIRST_TIFF_EXCHANGE"
                    : "TIFF_EXCHANGE_MIN"
                }
                visible={this.state.avoidNextStep}
                onOk={() => {
                  this.setState({ avoidNextStep: false });
                }}
                onCancel={() => {
                  this.setState({ avoidNextStep: false });
                }}
              />
              <PopUp
                type="INTO_TIFF_NEXT_DISABLED"
                visible={this.state.intoTiffButton}
                onOk={() => {
                  this.setState({ intoTiffButton: false });
                }}
                onCancel={() => {
                  this.setState({ intoTiffButton: false });
                }}
              />
              <PopUp
                type="MAX_POOL_BALANCE"
                visible={this.state.isMaxPoolLimit}
                onOk={() => {
                  this.setState({ isMaxPoolLimit: false });
                }}
                onCancel={() => {
                  this.setState({ isMaxPoolLimit: false });
                }}
                poolName={this.state.popUpPoolName}
              />
            </>
          )}
      </>
    );
  }
}

TIFFTypeSelection.propTypes = {
  setExchangeIntoTiff: PropTypes.func,
  investmentPools: PropTypes.array,
  stepConfig: PropTypes.object,
  dataStepOne: PropTypes.object,
  firstTiffExchnageFlag: PropTypes.bool,
  tiffInfoLoading: PropTypes.bool,
  disableFromOption: PropTypes.string,
}

export default TIFFTypeSelection;